import { DeleteOutlined, EditOutlined } from '@ant-design/icons'
import { ColDef, SelectionChangedEvent } from 'ag-grid-community'
import { AgGridReact } from 'ag-grid-react'
import { Button, ConfigProvider, Flex, Input, Pagination, PaginationProps, Switch, TableProps } from 'antd'
import viVN from 'antd/locale/vi_VN'
import React, { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import Layout from '../../../Layout'
import * as customerCareerApi from "../../../api/customerCareer/customerCareerApi"
import BreadcrumbBlock from '../../../components/BreadcrumbBlock/BreadcrumbBlock'
import ModalDeleteManager from '../../../components/ModalDeleteManager'
import useDebounce from '../../../hook/useDebounce'
import useLoading from '../../../hook/useLoading'
import useThrottle from '../../../hook/useThrottle'
import useToast from '../../../hook/useToast'
import { NO_DATA } from '../../../services/data'
import { formatNumber } from '../../../services/mixin'
import { selectorPermission } from '../../../store/slices/permissionSlice'
import { dataPagination, getUserPermissions } from '../../../until'
import AddCareerModal from './AddCareerModal'
import EditCareerModal from './EditCareerModal'

const { Search } = Input

interface TableDataType {
  key: React.Key
  code: string
  name: string
  status: number
}
type TableRowSelection<T extends object = object> = TableProps<T>['rowSelection']


const CustomerCareer: React.FC = () => {

  useEffect(() => {

    return () => {
      setSearchJob(undefined)
      gListCareer([])
      setPagination({ current: 1, pageSize: 10, total: 0 })
    }
  }, [])

  const location = useLocation();
  const pushLoading = useLoading()
  const pushToast = useToast(); const permissionSlice = useSelector(selectorPermission)
  const { add, edit, delete: isdelete, } = getUserPermissions(permissionSlice, location.pathname)

  const [showAddCareerModal, setShowAddCareerModal] = useState(false)
  const [showEditCareerModal, setShowEditCareerModal] = useState(false)
  const [showDeleteCareerModal, setShowDeleteCareerModal] = useState(false)

  const [loadingTable, setLoadingTable] = useState(false)


  const [paginationTmp, setPaginationTmp] = useState<number>(1)
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });
  const [searchJob, setSearchJob] = useState<string>()

  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([])
  const [idCareer, setIdCareer] = useState<number>()
  const [infoCustomerCareer, setInfoCustomerCareer] = useState<customerCareerApi.ICareerEdit>()
  const [listCustomerCareer, setListCustomerCareer] = useState<TableDataType[]>([])

  //#region: COLUMNS
  const memoizedColumnDefs = useMemo<ColDef<TableDataType>[]>(() => [
    {
      headerName: 'Hành động',
      field: 'key',

      width: 180,
      resizable: false,
      suppressMovable: true,
      lockPosition: 'left',

      cellRenderer: (params: any) => {
        const record = params.data as TableDataType;

        if (!record) return null;

        return (
          <div className='d-flex gap-2 align-center h-full'>
            <EditOutlined
              className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer ${!edit ? 'disabled' : ''}`}
              onClick={() => {
                if (edit) gInfoCareer(Number(record.key));
              }}
            />
            <DeleteOutlined
              className={`text-F5222D text-sm border-EAECF0 p-5-px bg-white rounded-2 cursor-pointer ${!isdelete ? 'disabled' : ''}`}
              onClick={() => {
                if (isdelete) openModalDeleteCareer(Number(record.key));
              }}
            />
          </div>
        );
      },
    },

    {
      headerName: 'Mã nghề nghiệp',
      field: 'code',

      width: 130,

      cellRenderer: (params: any) => {
        return (
          <div className="td-card-code">
            {params.value || NO_DATA}
          </div>
        );
      },
    },

    {
      headerName: 'Tên nghề nghiệp',
      field: 'name',
      width: 130,
      flex: 1,


      valueFormatter: (params) => {
        return params.value || NO_DATA;
      },
    },

    {
      headerName: 'Sử dụng',
      field: 'status',


      headerClass: 'ag-header-cell-right',

      cellStyle: {
        display: 'flex',
        alignItems: 'center',
      },

      cellRenderer: (params: any) => {
        const record = params.data as TableDataType;

        if (!record) return null;

        return (
          <Switch
            checked={Boolean(record.status)}
            onChange={() => {
              updateStatusCareer(Number(record.key));
            }}
            className="rs-switch"
          />
        );
      },
    },
  ], [edit, isdelete]);
  //#endregion

  //#region TABLE ROW SELECTION


  const onSelectionChanged = (
    event: SelectionChangedEvent<TableDataType>
  ) => {
    const selectedKeys = event.api
      .getSelectedRows()
      .map(item => item.key);

    setSelectedRowKeys(selectedKeys);

    console.log('selectedRowKeys:', selectedKeys);
  };

  const getRowId = (params: any) =>
    String(params.data.key);
  //#endregion


  // Danh sách nghề nghiệp
  const gListCareer = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
    setLoadingTable(true)
    const result = await customerCareerApi.gListCareer(pageSize, pageCurent, searchJob)
    if (result?.status) {
      setListCustomerCareer(convertData(result?.data, pageCurent, pageSize))
      setPagination({ current: pageCurent, total: result.total, pageSize })
      setPaginationTmp(pageCurent)
    } else {
      pushToast(result?.message, "warning")
    }
    setLoadingTable(false)
  }, 1000)

  const convertData = (data: customerCareerApi.ICareer[], pageCurent: number, pageSize: number) => {
    const converData = data.map((items) => ({
      key: items.id,
      name: items.title,
      status: items.status,
      code: items.code
    }))
    return converData
  }

  // Thông tin nghề nghiệp
  const gInfoCareer = useThrottle(async (id: number) => {
    pushLoading(true)
    const result = await customerCareerApi.gInfoCareer(id)
    if (result?.status) {
      setInfoCustomerCareer(result?.data)
      setShowEditCareerModal(true)
    } else {
      pushToast(result.message, "warning")
    }
    pushLoading(false)
  }, 1000)

  // Thêm nghề nghiệp
  const submitModalAdd = (iSsuccess: boolean, errorMessage?: string) => {
    if (iSsuccess) {
      setShowAddCareerModal(false)
      pushToast("Thêm nghề nghiệp thành công", "success")
      gListCareer()
    } else {
      pushToast(errorMessage, "warning")
    }
  }

  // Chỉnh sửa nghề nghiệp
  const submitModalEdit = (isSucces: boolean, errorMessage?: string) => {
    if (isSucces) {
      setShowEditCareerModal(false)
      pushToast("Chỉnh sửa nghề nghiệp thành công", "success")
      gListCareer(pagination.current, pagination.pageSize)
    } else {
      pushToast(errorMessage, "warning")
    }
  }

  const openModalDeleteCareer = (id: number) => {
    setIdCareer(id)
    setShowDeleteCareerModal(true)
  }

  const closeModalDeleteCareer = () => {
    setIdCareer(undefined)
    setShowDeleteCareerModal(false)
  }

  // Xóa nghề nghiệp
  const onDeleteCareer = async () => {
    pushLoading(true)
    const result = await customerCareerApi.deleteCareer(Number(idCareer))
    if (result.status) {
      pushToast("Xóa nghề nghiệp thành công", "success")
      closeModalDeleteCareer()
      gListCareer(pagination.current, pagination.pageSize)
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }

  // Update trạng thái
  const updateStatusCareer = async (id: number) => {
    pushLoading(true)
    const result = await customerCareerApi.updateStatusCareer(id)
    if (result?.status) {
      gListCareer(pagination.current, pagination.pageSize)
      pushToast(result.message, "success", 2000)
    } else {
      pushToast(result.message, "error", 2000)
    }
    pushLoading(false)
  }

  const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    setPaginationTmp(pageNumber);
    setPagination((prev) => ({ ...prev, current: pageNumber, pageSize }))
    gListCareer(pageNumber, pageSize)
  }

  useEffect(() => {
    gListCareer()
  }, [searchJob])
  return (
    <>
      {/* MODAL ADD CAREER */}
      <AddCareerModal
        show={showAddCareerModal}
        modalClose={() => setShowAddCareerModal(false)}
        onSubmitFormModal={submitModalAdd}
      />

      {/* MODAL EDIT CAREER */}
      <EditCareerModal
        show={showEditCareerModal}
        infoCustomerCareer={infoCustomerCareer}
        modalClose={() => setShowEditCareerModal(false)}
        onSubmitModalEdit={submitModalEdit}
      />

      {/* MODAL DELETE CAREER */}
      <ModalDeleteManager
        isOpen={showDeleteCareerModal}
        title='Xóa nghề nghiệp'
        titleDelete='Xóa'
        content='Nghề nghiệp và dữ liệu liên quan sẽ bị xóa vĩnh viễn không thể khôi phục'
        closeModal={closeModalDeleteCareer}
        onConfirm={onDeleteCareer}
      />
      <Layout className='customer-hobby'>
        <BreadcrumbBlock
          items={[
            { title: <Link to="/">THACO AUTO CRM</Link>, },
            { title: 'Khách hàng', },
            { title: 'Quản lý nghề nghiệp', },
          ]}
          title='Quản lý nghề nghiệp'
          className='gutter-block-end'
        />

        <Flex vertical className='gap-18px h-full'>
          <Flex align='center' className='gap-12px'>
            <Search
              placeholder="Tìm kiếm nghề nghiệp"
              allowClear
              className="custom-input-css"
              value={searchJob}
              onChange={(e) => setSearchJob(e.target.value)}
            />
            <Button
              type='primary'
              disabled={!add}
              onClick={() => setShowAddCareerModal(true)}
            >Thêm nghề nghiệp</Button>
          </Flex>
          <div className="custom-page-css flex flex-1 flex-col justify-between">
            <div
              className="ag-theme-alpine custom-table-ag custom-css-table"
              style={{
                width: '100%',
                height:
                  listCustomerCareer.length === 0
                    ? 250
                    : listCustomerCareer.length < 10
                      ? listCustomerCareer.length * 55 + 55
                      : 650,
              }}
            >
              <AgGridReact<TableDataType>
                rowData={listCustomerCareer}
                columnDefs={memoizedColumnDefs}

                getRowId={getRowId}

                rowHeight={55}
                headerHeight={48}

                defaultColDef={{
                  resizable: true,
                  sortable: true,
                }}

                rowSelection={{
                  mode: 'multiRow',
                  checkboxes: true,
                  headerCheckbox: true,
                  enableClickSelection: false,
                }}

                onSelectionChanged={onSelectionChanged}

                loading={loadingTable}

                overlayNoRowsTemplate="<span>Không có dữ liệu</span>"

                enableCellTextSelection
                ensureDomOrder

                getRowStyle={(params: any) => ({
                  backgroundColor:
                    params?.node?.rowIndex % 2
                      ? '#f7f9fc'
                      : '#ffffff',
                })}
              />
            </div>
            <ConfigProvider locale={viVN}>
              <div className="pagination-block">
                <Pagination
                  showSizeChanger
                  current={paginationTmp}
                  pageSize={pagination.pageSize}
                  total={pagination.total}
                  itemRender={(page, type, originalElement) => {
                    // Chỉ custom khi là nút số trang
                    if (type === 'page') {
                      return <span>{formatNumber(page)}</span>;
                    }
                    // prev / next / jump-prev / jump-next giữ nguyên
                    return originalElement;
                  }}
                  showTotal={(total) => `Tổng cộng ${dataPagination(pagination.total, pagination.pageSize, paginationTmp).totalPage} trang`}
                  className='rs-pagination'
                  onChange={onPaginationChange}
                />
              </div>
            </ConfigProvider>
          </div>
        </Flex>
      </Layout>


    </>
  )
}

export default CustomerCareer
